import { useState } from 'react'

import { UseMutationResult } from '@tanstack/react-query'
import { GetContextMenuItemsParams } from 'ag-grid-enterprise'
import { PowerOff } from 'lucide-react'
import { renderToString } from 'react-dom/server'

import { CustomMenuItem } from '@fortem-monorepo/react-ag'
import { useConfirmModal } from '@fortem-monorepo/react-spa'
import { Trades } from '@fortem-monorepo/web-sdk'

export type WithActiveProperty = {
  active: boolean | null | undefined
}

type Options = {
  mutation: UseMutationResult<any, Error, Trades.UpdateTradeParams, unknown>
}

export const useChangeActiveTradeMenuItem = <TData extends WithActiveProperty>(
  options: Options,
) => {
  const [chosenTrade, setChosenTrade] = useState<WithActiveProperty | null>(null)

  const { Dialog, withConfirmation } = useConfirmModal({
    title: chosenTrade?.active ? 'Deactivate trade' : 'Activate trade',
    description: `Are you sure you want to ${chosenTrade?.active ? 'dectivate' : 'activate'} this trade?`,
  })

  const createMenuItems = (params: GetContextMenuItemsParams<TData>) => {
    const data = params.node?.data
    const isActive = data?.active ?? false

    return [
      {
        name: isActive ? 'Deactivate trade' : 'Activate trade',
        icon: renderToString(<PowerOff size={16} />),
        cssClasses: isActive ? ['hover:bg-red-100!'] : ['hover:bg-green-100!'],
        action: () => {
          setChosenTrade(data!)

          return withConfirmation(() =>
            options.mutation.mutateAsync({
              rowData: data,
              updatedField: 'active',
              oldValue: isActive,
              newValue: !isActive,
            }),
          )
        },
      },
      'separator',
    ] satisfies CustomMenuItem[]
  }

  return {
    Dialog,
    createMenuItems,
  }
}
